import Nullstack from 'nullstack';
export default function IconRulerMeasure({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ruler-measure",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M19.875 12c.621 0 1.125 .512 1.125 1.143v5.714c0 .631 -.504 1.143 -1.125 1.143h-15.875a1 1 0 0 1 -1 -1v-5.857c0 -.631 .504 -1.143 1.125 -1.143h15.75z"
  }), "   ", Nullstack.element("path", {
    d: "M9 12v2"
  }), "   ", Nullstack.element("path", {
    d: "M6 12v3"
  }), "   ", Nullstack.element("path", {
    d: "M12 12v3"
  }), "   ", Nullstack.element("path", {
    d: "M18 12v3"
  }), "   ", Nullstack.element("path", {
    d: "M15 12v2"
  }), "   ", Nullstack.element("path", {
    d: "M3 3v4"
  }), "   ", Nullstack.element("path", {
    d: "M3 5h18"
  }), "   ", Nullstack.element("path", {
    d: "M21 3v4"
  }), " ");
}